import { render, staticRenderFns } from "./ManageOrganizationStep.vue?vue&type=template&id=33162d56&scoped=true"
import script from "./ManageOrganizationStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageOrganizationStep.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ManageOrganizationStep.vue?vue&type=style&index=0&id=33162d56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33162d56",
  null
  
)

export default component.exports